import React from 'react'
import R from 'ramda'
import {connect} from 'react-redux'

import VisibilitySensor from 'react-visibility-sensor'

import lastVisibleIndexChanged from '../actions/lastVisibleIndexChanged'

import LoadMore from './LoadMore'


class DelayedLoader extends React.Component {
  constructor(props){
    super(props)
    this.loadMore = this.loadMore.bind(this)
  }
  shouldComponentUpdate(nextProps){
    return !R.equals(this.props, nextProps)
  }
  loadMore(){
    const {batchSize} = this.props
    const computedNewLastVisible = this.props.lastVisibleIndex + batchSize 
    const lastVisibleIndex = Math.min(computedNewLastVisible, R.length(this.props.list))
    if(lastVisibleIndex !== this.props.lastVisibleIndex){
      this.props.lastVisibileIndexChanged(lastVisibleIndex)
    }
  }
  render(){
    const itemsToRender = R.slice(0, this.props.lastVisibleIndex, this.props.list)
    const loadCompleted = this.props.lastVisibleIndex == this.props.list.length
    return <div>
        {R.map(this.props.renderItem, itemsToRender)}
        { loadCompleted ? null : <VisibilitySensor delay={1000} onChange={isVisible => isVisible ? this.loadMore() : null}/> }
        { loadCompleted ? null : <LoadMore/> }
      </div>
  }
}

DelayedLoader.propsType = {
  children: React.PropTypes.array.isRequired,
  batchSize: React.PropTypes.number.isRequired,
}

const mapStateToProps = (state) => {
  return {
    lastVisibleIndex: state.lastVisibleIndex
  }
}

const mapDispatchToProps = dispatch => {
  return {
    lastVisibileIndexChanged: newLastVisibleIndex => dispatch(lastVisibleIndexChanged(newLastVisibleIndex))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DelayedLoader)



/** WEBPACK FOOTER **
 ** ./app/components/DelayedLoader.jsx
 **/